module.exports = __webpack_public_path__ + "public/images/netw-close.02215699a7b573742c47976167402a9b.svg";